import { FC } from "react";

import { FormTitle, FormWrapper } from "./components/MonolithFormComponents";
import { usePermissions } from "@/hooks/usePermissions";
import { useSnackbar, VariantType } from "notistack";
import LoggingAPI from "@/api/logging";

import DefaultGroupForm from "./DefaultGroupForm";
import UserGroupsAPI from "@/api/users/groups";

interface EditGroupFormProps {
  width?: number | undefined;
  defaultFormData: any;
  onSubmit: () => void;
  onCancel: () => void;
}

const EditGroupForm: FC<EditGroupFormProps> = ({
  width,
  defaultFormData,
  onSubmit,
  onCancel,
}) => {
  const { currentUser } = usePermissions();
  const { enqueueSnackbar } = useSnackbar();

  const handleSubmit = async (data: any, diffData?: any) => {
    console.log(data);
    console.log(diffData);
    try {
      await UserGroupsAPI.update({
        ...diffData,
        uuid: data.uuid,
      });
      onSubmit?.();
      enqueueSnackbar(`User Group ${data?.name || ""} Edited`, {
        variant: "success" as VariantType,
      });

      LoggingAPI.createLog({
        user_id: currentUser.user_id,
        message: `Edited User Group: ${data?.name}`,
        event: "user_group:edit",
        object_type: "user_group",
      });
    } catch (error) {
      console.error(error);
      enqueueSnackbar(
        `An error occurred while editing user group ${
          data?.name || ""
        }. Please try again.`,
        { variant: "error" as VariantType }
      );
    }
  };

  return (
    <FormWrapper width={width}>
      <FormTitle>Edit User Group</FormTitle>
      <DefaultGroupForm
        onSubmit={handleSubmit}
        onCancel={onCancel}
        defaultFormData={defaultFormData}
        buttonProps={{ submitText: "Save Changes" }}
      />
    </FormWrapper>
  );
};
export default EditGroupForm;
